"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Observer from "./observer";
import h from "../helper/helper";
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress(options) {
        var _this = _super.call(this) || this;
        _this.done = 0;
        _this.donePercentage = 0;
        _this.data = { progress: 0 };
        _this._parseOptions = function () {
            if (_this.options) {
                _this.total = _this.options.total;
                if (_this.options.depends) {
                    _this._listenDepends(_this.options.depends);
                }
            }
        };
        _this._listenDepends = function (depends) {
            _this.depends = depends;
            depends.forEach(function (depend) {
                depend.listen(_this.recalculate.bind(_this), "progress");
            });
        };
        _this.removeDepend = function (depend) {
            if (!_this.depends && _this.total) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            h.removeArray(_this.depends, depend);
            _this.recalculate();
        };
        _this.addDepend = function (depend) {
            if (!_this.depends && _this.total) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.depends = _this.depends || [];
            _this.depends.push(depend);
            depend.listen(_this.recalculate.bind(_this), "progress");
            _this.recalculate();
        };
        _this.progressDelta = function (delta) {
            if (_this.depends) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.done += delta;
            _this.recalculate();
        };
        _this.progress = function (done) {
            if (_this.depends) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.done = done;
            _this.recalculate();
        };
        _this.setTotal = function (total) {
            if (_this.depends) {
                throw new Error("trying to mix depending progress and manual progress");
            }
            _this.total = total;
            _this.recalculate();
        };
        _this.reset = function () {
            _this.done = 0;
            _this.recalculate();
        };
        _this.joinDepends = function () {
            var done = 0, total = 0;
            _this.depends.forEach(function (depend) {
                done += depend.getDone();
                total += depend.getTotal() || 0;
            });
            _this.done = done;
            _this.total = total;
        };
        _this.getDone = function () {
            return _this.done;
        };
        _this.getTotal = function () {
            return _this.total;
        };
        _this.getProgress = function () {
            return _this.donePercentage;
        };
        _this.recalculate = function () {
            if (_this.depends) {
                _this.joinDepends();
            }
            if (!_this.total) {
                return;
            }
            _this.donePercentage = _this.done / _this.total;
            _this.donePercentage = Math.min(_this.donePercentage, 1);
            _this.data.progress = _this.donePercentage;
            _this.notify(_this.donePercentage, "progress");
        };
        _this.options = options;
        _this._parseOptions();
        return _this;
    }
    return Progress;
}(Observer));
export default Progress;



//////////////////
// WEBPACK FOOTER
// ./js/asset/Progress.ts
// module id = P6+u
// module chunks = 1 2 3